import React, { useEffect, useState } from 'react';
import { getFaultyLoansByWorkshop } from '../../Api/Api';
import { useNotification } from '../Notification/NotificationContext';
import { useWorkshop } from '../Common/WorkshopContext';
import Pagination from '../Pagination/Pagination';
import { FaSearch } from 'react-icons/fa';

const FaultyLoans = () => {
    const { workshopId } = useWorkshop();
    const [loans, setLoans] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const pageSize = 10;
    const { showNotification } = useNotification();

    useEffect(() => {
        fetchFaultyLoans(currentPage);
    }, [currentPage, searchTerm]);

    const fetchFaultyLoans = (page: number) => {
        getFaultyLoansByWorkshop(workshopId, pageSize, page, searchTerm)
            .then((response) => {
                setLoans(response.data.content);
                setTotalPages(response.data.totalPages);
                setTotalCount(response.data.totalElements);
            })
            .catch((error) => {
                showNotification(error.message, 'error');
            });
    };

    return (
        <div className="bg-white rounded-2xl shadow-lg p-6 mt-6">
            <div className="flex flex-col md:flex-row justify-between items-center mb-4">
                <h2 className="text-xl font-semibold text-gray-800">Loans with Due Penalties</h2>
                {/*<div className="relative mt-2 md:mt-0">*/}
                {/*    <input*/}
                {/*        type="text"*/}
                {/*        placeholder="Search by customer or loan ID..."*/}
                {/*        className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:outline-none text-sm"*/}
                {/*        value={searchTerm}*/}
                {/*        onChange={(e) => {*/}
                {/*            setCurrentPage(0);*/}
                {/*            setSearchTerm(e.target.value);*/}
                {/*        }}*/}
                {/*    />*/}
                {/*    <FaSearch className="absolute top-2.5 left-3 text-gray-400 text-sm" />*/}
                {/*</div>*/}
            </div>

            <div className="overflow-x-auto rounded-lg border border-gray-200">
                <table className="min-w-full text-sm text-gray-700">
                    <thead className="bg-gray-50">
                    <tr>
                        <th className="py-3 px-4 text-left font-semibold">Loan ID</th>
                        <th className="py-3 px-4 text-left font-semibold">Customer</th>
                        <th className="py-3 px-4 text-left font-semibold">Loan Amount</th>
                        <th className="py-3 px-4 text-left font-semibold">Total Penalty Due</th>
                        <th className="py-3 px-4 text-left font-semibold">Start Date</th>
                        <th className="py-3 px-4 text-left font-semibold">End Date</th>
                        <th className="py-3 px-4 text-left font-semibold">Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    {loans?.map((item: any) => (
                        <tr key={item.loan.id} className="border-t hover:bg-gray-50 transition">
                            <td className="py-2 px-4 font-medium">{item.loan.id}</td>
                            <td className="py-2 px-4">{item.loan.customer?.name}</td>
                            <td className="py-2 px-4">₹{item.loan.loanAmount?.toLocaleString() || 0}</td>
                            <td className="py-2 px-4 text-red-600 font-semibold">₹{item.totalPenalty?.toLocaleString()}</td>
                            <td className="py-2 px-4">{new Date(item.loan.startDate).toLocaleDateString()}</td>
                            <td className="py-2 px-4">{new Date(item.loan.endDate).toLocaleDateString()}</td>
                            <td className="py-2 px-4">
                                    <span className="px-2 py-1 text-xs font-medium rounded-full bg-red-100 text-red-700 uppercase tracking-wide">
                                        {item.loan.status}
                                    </span>
                            </td>
                        </tr>
                    ))}
                    {loans?.length === 0 && (
                        <tr>
                            <td className="py-6 px-4 text-center text-gray-400" colSpan={7}>
                                No faulty loans found.
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="mt-4 flex justify-between items-center">
                <p className="text-sm text-gray-500">Showing page {currentPage + 1} of {totalPages}</p>
                <Pagination
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                    totalCount={totalCount}
                />
            </div>
        </div>
    );
};

export default FaultyLoans;
